import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import IconArrow from './icons/iconArrow';
import { updateAreaOpen, updateTransition, updateMenuOpen } from '../store/globalReducer';

import '../assets/scss/components/header.scss';

function BackgroundMid({ colorVal }) {
  return (
    <svg viewBox="0 0 42 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42 16H0C4.29849 16 7.78312 12.4184 7.78312 8C7.78312 3.5816 4.29849 0 0 0H42C37.7015 0 34.2169 3.5816 34.2169 8C34.2169 12.4184 37.7015 16 42 16Z"
        fill={colorVal} />
    </svg>
  )
}

export default function Header() {
  const location = useLocation();
  const dispatch = useDispatch();

  const isMenuOpen = useSelector(state => state.global.isMenuOpen);
  const isAreaOpen = useSelector(state => state.global.isAreaOpen);
  const templeList = useSelector(state => state.temples.templeData);
  const [headerType, setHeaderType] = useState('index');
  const [originPage, setOriginPage] = useState('index');

  useEffect(() => {
    if (location.pathname === '/' && !isAreaOpen) setHeaderType('index');
    else if (location.pathname === '/' && isAreaOpen) setHeaderType('area');
    else setHeaderType('detail');
  }, [location, headerType, isAreaOpen]);

  useEffect(() => {
    const currentTempleName = location.pathname.replace('/', '');
    const currentTemple = templeList.find(el => el.name_en === currentTempleName);

    (currentTemple) && setOriginPage(currentTemple.show_on_map);
  }, [location, templeList]);

  const handleBackClick = e => {
    e.preventDefault();
    dispatch(updateAreaOpen(false));
    dispatch(updateTransition(true));
  }

  const handleTriggerClick = e => {
    e.preventDefault();
    dispatch(updateMenuOpen(true));
  }

  const indexSub = () => (<p>全体マップ</p>);
  const areaSub = () => (
    <a href="#" onClick={e => handleBackClick(e)}>
      <i><IconArrow></IconArrow></i>
      <span>全体マップへ</span>
    </a>
  );
  const detailSub = () => (
    <Link to={`/`} onClick={e => dispatch(updateAreaOpen(originPage === 'area'))}>
      <i><IconArrow></IconArrow></i>
      <span>マップに戻る</span>
    </Link>
  );

  return (
    <header className="header">
      <div className="header__sitename">
        <h1>須崎カミサマップ</h1>
        <div className="header__bg header__bg--white"><BackgroundMid colorVal="#fff" /></div>
        <div className="header__bg header__bg--primary"><BackgroundMid colorVal="#990D00" /></div>
      </div>
      <div className="header__sub">
        { headerType === 'index' ? indexSub()
          : headerType === 'area' ? areaSub()
          : detailSub() }
      </div>
      <motion.div
        className="header__trigger"
        initial={{ x: '0%' }}
        animate={isMenuOpen
          ? { x: '100%', transition: {ease: 'easeOut', duration: 0.3 } }
          : { x: '0%', transition: { ease: 'easeOut', duration: 0.3, delay: 0.35 } }}>
        <a href="#" onClick={handleTriggerClick}><span></span><span></span></a>
      </motion.div>
    </header>
  );
}